import wrapError from "@/components/helpers/wrapError"

export const updateExperience = (url) => (experience, success, error) => {
  $.ajax({
    type: "PUT",
    url: `/api/${url}/${experience.id}`,
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(experience),
    success,
    error: wrapError(error, "updateExperience"),
  })
}

export const deleteExperience = (url) => (experience, success, error) => {
  $.ajax({
    type: "DELETE",
    url: `/api/${url}/${experience.id}`,
    success,
    error: wrapError(error, "deleteExperience"),
  })
}

export const createExperience = (url) => (experience, success, error) => {
  $.ajax({
    type: "POST",
    url: `/api/${url}`,
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(experience),
    success,
    error: wrapError(error, "createExperience"),
  })
}
